import { daysBetween, formatAdults, formatDayShort, formatRouteDates, todayInSaoPaulo } from '@viaja/domain';

export { formatAdults, formatDay, formatDayShort, formatRouteDates, money, brl } from '@viaja/domain';

const TZ = 'America/Sao_Paulo';

/** "hoje às 07:02", "ontem às 07:02", "12 out às 07:02" */
export function formatCheckedAt(iso: string): string {
  const d = new Date(iso);
  const time = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: TZ });
  const day = todayInSaoPaulo(d);
  const diff = daysBetween(day, todayInSaoPaulo());
  if (diff === 0) return `hoje às ${time}`;
  if (diff === 1) return `ontem às ${time}`;
  return `${formatDayShort(day)} às ${time}`;
}

/** Linha de apoio do campo "Quando": "Ida e volta · 1 adulto · só voos diretos". */
export function tripKindDetail(returnDate: string | null, adults: number, directOnly: boolean): string {
  return [returnDate ? 'Ida e volta' : 'Só ida', formatAdults(adults), directOnly ? 'só voos diretos' : null]
    .filter(Boolean)
    .join(' · ');
}

/** Linha da rota nos cards: "21–28 mai 2027 · ida e volta". */
export const routeDates = (outbound: string, ret: string | null) => formatRouteDates(outbound, ret);

/** Período de uma viagem: "21–28 mai 2027" ou "Datas a definir". */
export function tripPeriod(start: string | null, end: string | null): string {
  if (start && end) return formatRouteDates(start, end, false);
  if (start) return `A partir de ${formatRouteDates(start, null, false)}`;
  return 'Datas a definir';
}
